<template>
  <section v-if="show" class="tw-pb-8" style="padding-top: 0;">
    <div class="container body-copy">
      <div class="tac" v-if="btn1.url">
        <a
          class="tac jwb-button orange-black"
          style="margin-top: 0;"
          :href="btn1.url"
          target="_blank"
        >
          {{ btn1.title }}
        </a>
      </div>

      <div class="tac" v-if="btn2.url">
        <a class="tac jwb-button orange-black" :href="btn2.url" target="_blank">
          {{ btn2.title }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    show: { type: String, default: '' },
    btn1: { type: Object, default: () => {} },
    btn2: { type: Object, default: () => {} },
  },
}
</script>

<style lang="scss"></style>
